import KControl from '../../core/mixins/control/KControl'
import KEmitter from '../../core/mixins/emitter/KEmitter'
import Button from '../button'
import Icon from '../icon'
import { KeyCode } from '../../core/KConstants'
import $ from 'jquery'
import _ from 'lodash'

export default {
  name: 'KCheckbox',
  mixins: [KControl, KEmitter],
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    type: {
      type: String,
      default: 'primary',
    },
    name: {
      type: String,
      default: '',
    },
    checked: {
      validator: (value) => _.isBoolean(value) || _.isArray(value),
      default() {
        return null
      },
    },
    value: {
      validator: () => true,
      default() {
        return null
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
    noRipple: {
      type: Boolean,
      default: true,
    },
    anim: {
      type: Boolean,
      default: false,
    },
    pure: {
      type: Boolean, // 不显示默认样式和模板
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    circle: {
      type: Boolean,
      default: false,
    },
    // 值为Object，使用此key作为checkbox比较标志
    objectValueKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  computed: {
    isMultiple() {
      return _.isArray(this.checked)
    },
    innerChecked() {
      if (this.isMultiple) {
        let checkIndex = this.checked.indexOf(this.value)
        if (_.isObject(this.value) && this.objectValueKey) {
          checkIndex = _.findIndex(this.checked, [this.objectValueKey, this.value[this.objectValueKey]])
        }
        return checkIndex !== -1
      } else {
        return this.checked
      }
    },
  },
  watch: {},
  created() {
    if (!this.isMultiple && _.isNil(this.value) && this.checked !== true) {
      this.$emit('change', false)
    }

    this.$nextTick(() => {
      this.lastInnerChecked = this.innerChecked
      this.lastIndeterminate = this.indeterminate
    })
  },
  mounted() {},
  render() {
    const attrs = {
      attrs: {
        tabindex: 0,
      },
    }

    const checkboxCss = {
      class: {
        'is-disabled': this.disabled,
        'km-checkbox--checked': this.innerChecked,
        'km-checkbox--pure': this.pure,
        [`km-checkbox--${this.type}`]: true,
        [`km-checkbox--small`]: this.small,
        [`km-checkbox--indeterminate`]: this.indeterminate,
      },
    }

    const innerLabel = this.renderInnerLabel()

    return (
      // 使用 div 而非 label，是为了兼容 safari 里面事件问题
      <div
        class="km-checkbox km-control"
        onKeydown={this.handleKeydown}
        {...checkboxCss}
        {...attrs}
      >
        {this.pure ? (
          <input
            class="km-checkbox__input"
            ref="input"
            type="checkbox"
            name={this.name}
            disabled={this.disabled}
            checked={this.innerChecked}
            onChange={this.handleChange}
            onClick={this.handleClick}
            noRipple={this.noRipple}
          />
        ) : this.renderCheckboxIcon()}
        {innerLabel}
      </div>
    )
  },
  methods: {
    renderCheckboxIcon() {
      const iconCss = {
        class: {
          'km-checkbox__icon--checked': this.innerChecked,
          'km-checkbox__icon--anim': this.anim,
          'km-checkbox__icon--circle': this.circle,
        },
      }

      if (this.anim) {
        const fromChecked2Indeterminate = this.lastInnerChecked && this.indeterminate
        const fromIndeterminate2Checked = this.lastIndeterminate && this.innerChecked
        const keepIndeterminate = this.lastIndeterminate && this.indeterminate
        this.lastInnerChecked = this.innerChecked
        this.lastIndeterminate = this.indeterminate
        _.assign(iconCss.class, {
          'indeterminate-to-checked': fromIndeterminate2Checked,
          'checked-to-indeterminate': fromChecked2Indeterminate,
          'indeterminate-to-indeterminate': keepIndeterminate,
        })
      }

      return (
        <div class="km-checkbox__icon" {...iconCss}
             onClick={this.noRipple ? this.handleButtonClick : _.noop}>
          {
            this.anim
              ? null
              : <Icon name={this.indeterminate ? 'minus' : 'check'}/>
          }
          <input
            class="km-checkbox__input"
            ref="input"
            type="checkbox"
            name={this.name}
            disabled={this.disabled}
            checked={this.innerChecked}
            onChange={this.handleChange}
          />

          {this.noRipple
            ? null
            : <Button
              class="km-checkbox__ripple"
              disabled={this.disabled}
              onClick={this.handleButtonClick}
              ref="button"
              circle
              plain
              size={this.small ? '' : 'large'}
              type={this.type}
              noRipple={this.noRipple}
            />
          }
        </div>
      )
    },
    renderInnerLabel() {
      if (this.$slots.default) {
        return (
          <div onClick={this.handleLabelClick} class="km-checkbox__label">
            {this.$slots.default}
          </div>
        )
      }
    },
    handleKeydown(e) {
      if (e.which === KeyCode.ENTER) {
        $(this.$el).trigger('click')
      }
    },
    handleButtonClick() {
      this.$refs.input && this.$refs.input.click()
    },
    handleLabelClick() {
      this.handleButtonClick()
      // this.$refs.button && this.$refs.button.emulateForceClick()
    },
    handleClick(e) {
      e.stopPropagation()
    },
    handleChange(e) {
      const checked = e.target.checked

      if (this.isMultiple) {
        let index = this.checked.indexOf(this.value)
        if (_.isObject(this.value) && this.objectValueKey) {
          index = _.findIndex(this.checked, [this.objectValueKey, this.value[this.objectValueKey]])
        }
        const has = index !== -1

        if (checked && !has) {
          this.checked.push(this.value)
        } else if (!checked && has) {
          this.checked.splice(index, 1)
        }

        this.$emit('change', this.checked)
        this.dispatch('KFormItem', 'k.form.change', [this.checked])
      } else if (_.isBoolean(this.checked)) {
        this.$emit('change', checked)
        this.dispatch('KFormItem', 'k.form.change', [this.checked])
      }
    },
  },
}
